import apiClient from './apiClient'
import type { FeedbackSubmission, SubmitFeedbackResponse } from '@/types/api'

/**
 * POST /api/feedback
 * Records one or more feedback entries: a single live submission, or the whole queue flushed on
 * reconnect. Returns 403 while the FeedbackEnabled app setting is off.
 */
export async function submitFeedback(
  items: FeedbackSubmission[]
): Promise<SubmitFeedbackResponse> {
  const { data } = await apiClient.post<SubmitFeedbackResponse>('/feedback', { items })
  return data
}
